// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__UCZYM","form":"styles_form__2R_MO"};